import { useTranslation } from "react-i18next";
import DigitalServicesHero from "../digitalServicesHero";
import SolutionsView from "../solutionsView";
import TechStackList from "../techStackList";
import projectsData from '../../../assets/data/projects.json';
import { Stack } from "@mui/material";
import ButtonComponent from "../../../components/form/buttonComponent";
import { useEffect, useCallback, useState } from "react";
import ProjectDetails from "../projectDetails";
import GetQuote from '../../contactUs/getQuote';
import companyData from '../../../assets/data/company.json';

const key = "services.digital.cloud";

const techStackList = [
    { src: "/images/tech-stack/AWS.png", alt: "AWS" },
    { src: "/images/tech-stack/MicrosoftAzure.png", alt: "Microsoft Azure" },
    { src: "/images/tech-stack/GoogleCloudPlatform.png", alt: "Google Cloud Platform" },
    { src: "/images/tech-stack/DigitalOcean.png", alt: "DigitalOcean" },
    { src: "/images/tech-stack/Kubernetes.png", alt: "Kubernetes" },
    { src: "/images/tech-stack/Docker.png", alt: "Docker" },
    { src: "/images/tech-stack/Firebase.png", alt: "Firebase" },
    { src: "/images/tech-stack/MongoDB.png", alt: "MongoDB" },
    { src: "/images/tech-stack/PostgreSQL.png", alt: "PostgreSQL" },
    { src: "/images/tech-stack/Jenkins.png", alt: "Jenkins" },
    { src: "/images/tech-stack/Auth0.png", alt: "Auth0" },
    { src: "/images/tech-stack/Cloudflare.png", alt: "Cloudflare" },
    { src: "/images/tech-stack/Kafka.png", alt: "Kafka" },
    { src: "/images/tech-stack/RabbitMQ.png", alt: "RabbitMQ" },
    { src: "/images/tech-stack/Git.png", alt: "Git" }
];

const CloudSolutionsLayout = () => {
    const {t} = useTranslation();

    const solutionsList = [
        {title: t(`${key}.categories.1.label`), description: t(`${key}.categories.1.description`), icon: '/images/icons/cloud-save.svg'},
        {title: t(`${key}.categories.2.label`), description: t(`${key}.categories.2.description`), icon: '/images/icons/cloud.svg'},
        {title: t(`${key}.categories.3.label`), description: t(`${key}.categories.3.description`), icon: '/images/icons/api.svg'},
        {title: t(`${key}.categories.4.label`), description: t(`${key}.categories.4.description`), icon: '/images/icons/chip.svg'}
    ];

    const [getQuote, setGetQuote] = useState(false);

    const getAQuote = useCallback(() => {
        // setGetQuote(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <DigitalServicesHero 
                banner="/images/services/digital/cloud/cloudBanner.png"
                title={t(`${key}.label`)}
                description={t(`${key}.description`)}
                imageLgSize="60%"
                bannerBottomSpacing={2}
            />

            <SolutionsView list={solutionsList}/>

            <TechStackList list={techStackList}/>

            <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                width='100%'
                pt={{xs: 2, md: 10}}
                pb={{xs: 2, md: 0}}
            >
                <ButtonComponent 
                    label={t('services.interested')}
                    onClick={getAQuote}
                    sx={{
                        animation: 'bounceButton 1s infinite'
                    }}
                />
            </Stack>

            <GetQuote open={getQuote} setOpen={setGetQuote}/>
        </>
    );
}

export default CloudSolutionsLayout;